import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Simulator from "@/pages/Simulator";
import SessionReport from "@/pages/SessionReport";
import FacilitatorDashboard from "@/pages/FacilitatorDashboard";
import SourcesPage from "@/pages/SourcesPage";
import { AudioControls } from "@/components/sim/AudioControls";
import { QuickExit } from "@/components/sim/QuickExit";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <div className="App min-h-screen bg-background font-body">
        <BrowserRouter>
          <main>
            <Routes>
              <Route path="/" element={<Simulator />} />
              <Route path="/report/:sessionId" element={<SessionReport />} />
              <Route path="/dashboard" element={<FacilitatorDashboard />} />
              <Route path="/sources" element={<SourcesPage />} />
            </Routes>
          </main>
          <AudioControls />
          <QuickExit />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </MotionConfig>
  );
}

export default App;
